import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const AllCast = () => {
  const { castid } = useParams();
  const [allCast, setAllCast] = useState([]);
  const [castMovieName, setCastMovieName] = useState([]);

  async function getCastMovieName() {
    const data = await fetch(
      `https://api.themoviedb.org/3/movie/${castid}?api_key=375735221c3b7b45a786c79616eae571&language=en-US`
    );
    const res = await data.json();
    // console.log(res.original_title, "all", castid);
    setCastMovieName(res.original_title);
  }

  useEffect(() => {
    async function getCast() {
      const data = await fetch(
        `https://api.themoviedb.org/3/movie/${castid}/credits?api_key=375735221c3b7b45a786c79616eae571&language=en-US`
      );
      const res = await data.json();
      console.log(res);
      setAllCast(res.cast);
    }

    getCast();
    getCastMovieName();
  }, []);
  return (
    <div>
      <p
        style={{ marginTop: "2rem", fontSize: "2rem" }}
        className="top-cast-title"
      >
        ALL CAST OF : {castMovieName}
      </p>
      <div className="grid-cast-container">
        {allCast &&
          allCast.map((cast) => (
            <>
              <div className="cast-box" key={cast.name}>
                <div className="cast-image-box">
                  {cast.profile_path ? (
                    <img
                      className="cast-img"
                      src={`https://image.tmdb.org/t/p/original${cast.profile_path}`}
                      alt="images of cast"
                    />
                  ) : (
                    <img
                      className="no-cast-img"
                      src={`https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-4-user-grey-d8fe957375e70239d6abdd549fd7568c89281b2179b5f4470e2e12895792dfa5.svg`}
                      alt="images of cast"
                    />
                  )}
                </div>
                <div className="cast-name-box">
                  <p className="cast-name">{cast.name}</p>
                  <p className="cast-character">{cast.character}</p>
                </div>
              </div>
            </>
          ))}
      </div>
    </div>
  );
};

export default AllCast;
